export const SIDEBAR_SET_CONTENT = 'SIDEBAR_SET_CONTENT';
export const SET_OPEN_SIDEBAR = 'SET_OPEN_SIDEBAR';
export const SET_OPEN_DRAWER = 'SET_OPEN_DRAWER';

export const setContentType = (contentType) => ({
  type: SIDEBAR_SET_CONTENT,
  contentType
});

export const setOpenSideBar = open => ({
  type: SET_OPEN_SIDEBAR,
  open
});

export const setOpenDrawer = open => ({
  type: SET_OPEN_DRAWER,
  open
});